import React from "react"
import { TextField, SxProps, Theme } from "@mui/material"

const textInputDefaultSx: SxProps<Theme> = {
  '& .MuiInputBase-root': {
    height: 36,
  },
}

type TextInputProps = {
  placeholder?: string
  fullWidth?: boolean
  htmlInputProps?: React.InputHTMLAttributes<HTMLInputElement>
  sx?: SxProps<Theme>
  value?: string
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  onBlur?: () => void
  name?: string
  error?: boolean
  helperText?: React.ReactNode
}

export const TextInput = React.forwardRef<HTMLInputElement, TextInputProps>(
  (
    {
      placeholder = "",
      fullWidth = true,
      htmlInputProps,
      sx,
      value = '',
      onChange,
      onBlur,
      name,
      error,
      helperText,
    },
    ref
  ) => {
    const resolvedSx = Array.isArray(sx)
      ? [textInputDefaultSx, ...sx]
      : sx
        ? [textInputDefaultSx, sx]
        : textInputDefaultSx

    return (
      <TextField
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        fullWidth={fullWidth}
        slotProps={{
          htmlInput: htmlInputProps,
        }}
        error={error}
        helperText={helperText}
        sx={resolvedSx}
        inputRef={ref}
      />
    )
  }
)
